import axiosConfig from '../utils/axiosConfigInstance';

export const getLessonPlans = async () => {
	const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/lesson-plan`);
	return response.data;
};

export const getLessonPlanById = async (id) => {
	const response = await axiosConfig.get(`${import.meta.env.VITE_APP_API_URL}/lesson-plan/${id}`);
	return response.data;
};

export const createLessonPlan = async (data) => {
	const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/lesson-plan`, data);
	return response.data;
};

export const updateLessonPlan = async (id, data) => {
	const response = await axiosConfig.put(`${import.meta.env.VITE_APP_API_URL}/lesson-plan/${id}`, data);
	return response.data;
};

export const deleteLessonPlan = async (id) => {
	const response = await axiosConfig.delete(`${import.meta.env.VITE_APP_API_URL}/lesson-plan/${id}`);
	return response.data;
};

export const compressLessonPlanPdf = async (fileUrl) => {
	const response = await axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/lesson-plan/compress-pdf`, { fileUrl });
	return response.data;
};

export const lessonPlanApis = {
	getLessonPlans,
	getLessonPlanById,
	createLessonPlan,
	updateLessonPlan,
	deleteLessonPlan,
	compressLessonPlanPdf,
};
